var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{key:_vm.id,class:_vm.className,style:(_vm.styleObj),attrs:{"aria-hidden":"true","focusable":"false"}},[_c('use',{attrs:{"xlink:href":_vm.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }